import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
const pdfDownloader = async (rootElementId, fileName = "sample.pdf") => {
  
const waitForImagesToLoad = (element) => {
  const images = element.querySelectorAll("img");
  const promises = Array.from(images).map((img) => {
    if (img.complete) return Promise.resolve();
    return new Promise((resolve) => {
      img.onload = resolve;
      img.onerror = resolve; // resolve even on error to not block
    });
  });
  return Promise.all(promises);
};

  const input = document.getElementById(rootElementId);
  await waitForImagesToLoad(input); // <--- wait for images to load
  const canvas = await html2canvas(input, { scrollY: -window.scrollY, scrollX: -window.scrollX, scale: 2, useCORS: true});
  const image = canvas.toDataURL('image/jpeg', 0.5);
  const pdf = new jsPDF('p', 'px', 'a4');

    const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const widthRatio = pageWidth / canvas.width;
  const heightRatio = pageHeight / canvas.height;
  const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

  const canvasWidth = canvas.width * ratio;
  const canvasHeight = canvas.height * ratio;

  const marginX = (pageWidth - canvasWidth) / 2;
  const marginY = (pageHeight - canvasHeight) / 2;

    pdf.addImage(image, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);
    pdf.save(fileName);
    //pdf.output('datauri', fileName)

}

export default pdfDownloader;